import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { AcademyFetchingClient } from './utils/DataFetchingClient';
export const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
const getNewDataFetchingClient = () => new AcademyFetchingClient({
  assumeImmutableResults: true
});
export let dataFetchingClient = getNewDataFetchingClient();
export const reinitialiseDataFetchingClient = async () => {
  dataFetchingClient.stop();
  await dataFetchingClient.clearStore();
  dataFetchingClient = getNewDataFetchingClient();
};